// extracted by mini-css-extract-plugin
export var above = "_3r-2";
export var basic = "_3r-5";
export var basicLabel = "_3r-4";
export var below = "_3r-3";
export var colorCircle = "_3r-0";
export var popover = "_3r-1";